import React, { useRef, useState, useEffect } from "react";
import { API_RESPONSE } from "../../../utills/app-constant";
import { toastEmitter } from "../../../utills/utilities";
import { EmployeeBulkUploads, getAllCompanies } from "../../../services/api-services";
import UploadModel from "../../components/common/UploadModal";
import TableHeading from "../../components/common/TableHeading";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../services/url-constant";

const EmployeeBulkUpload = ({ onUploadSuccess }) => {
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedFileName, setSelectedFileName] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [uploadApi, setUploadApi] = useState(false);
  const [formDataValue, setformDataValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pending, setPending] = useState(false);

  const dropRef = useRef(null);

  // Fetch all companies
  const getallCompany = async () => {
    setPending(true);
    try {
      const response = await getAllCompanies();
      if (response?.data?.responseCode === 404) {
        setCompanyList([]);
      } else if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody.map((data) => ({
          value: data?.id,
          label: data?.companyName,
        }));
        setCompanyList(companyOptions);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallCompany();
  }, []);


  //Handle file selection
  const handleFile = (file) => {
    if (!file || file.type !== "text/csv") {
      toastEmitter("error", "Please upload a valid CSV file!");
      return;
    }

    const formdata = new FormData();
    formdata.append("file", file);
    setSelectedFileName(file.name);
    setformDataValue(formdata);
    setUploadApi(true);
    setModalOpen(true);
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    handleFile(file);
    event.target.value = null;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    dropRef.current.classList.add("drag-over");
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    dropRef.current.classList.remove("drag-over");
  };

  const handleDrop = (event) => {
    event.preventDefault();
    dropRef.current.classList.remove("drag-over");
    const file = event.dataTransfer.files[0];
    handleFile(file);
  };

  //Upload CSV to correct backend API (6102)
  const handleEmployeebulkupload = async (companyId) => {
    if (!uploadApi || !formDataValue || !companyId) {
      toastEmitter("error", "Please select a company before uploading!");
      return;
    }
    try {
      setLoading(true);
      const response = await EmployeeBulkUploads(companyId, formDataValue);

      if (response?.data?.responseCode === 200) {
        toastEmitter("success", "CSV uploaded successfully!");
        if (onUploadSuccess) onUploadSuccess();

        setModalOpen(false);
        setSelectedCompany("");
        setUploadApi(false);
        setSelectedFileName("");
        setformDataValue(null);

      } else if (response?.data?.responseCode === 400) {
        toastEmitter("error", response?.data?.message || "Upload failed");
        setModalOpen(false);
        setUploadApi(false);
      } else {
        toastEmitter("error", response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setLoading(false);
    }

  };

  const handleDownload = () => {
    const baseUrl = API_URL.fileURL;
    const link = document.createElement("a");
    // const locale = navigator.language || "en-US";
    // const commaLocales = ["en-US", "en", "en-IN", "en-GB", "en-CA", "en-AU"];
    // const isComma = commaLocales.some(l => locale.startsWith(l));
    // if (isComma == true) {
    //   link.href = `${baseUrl}/en/Employeebulkupload.csv`;
    // } else {
    //   link.href = `${baseUrl}/fr/Employeebulkupload.csv`;
    // }
    link.href = `${baseUrl}/fr/Employeebulkupload.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <TableHeading
          firstData="Employee Bulk Upload"
          className="fs-18"
          TableHeading="align-items-center d-flex justify-content-center"
        />
        <div className="px-3">
          <button
            className="btn btn-primary fs-md-12 px-md-3 px-2"
            onClick={handleDownload}
          >
            Download CSV Format
          </button>
        </div>
      </div>

      {/* Company Selection */}
      <div className="dropdown-container ms-3">
        <div className="row ">
          <div className="col-md-6">
            <label className="input-label">Select Comapny <span className="text-danger">*</span></label>
            <select
              className="form-select form-control inputText-lable"
              value={selectedCompany}
              onChange={(e) => setSelectedCompany(e.target.value)}
              disabled={pending}

            >
              <option value="">Select Company</option>
              {
                companyList?.map((company) => (
                  <option key={company?.value} value={company?.value}>
                    {company?.label}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>

      {/* Upload Section */}
      <div className="p-3">
        <div className="Bulk_upload">
          <div
            ref={dropRef}
            className="p-5 d-flex flex-column justify-content-center align-items-center text-center border-dashed bg-light"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{
              minHeight: "200px",
              cursor: "pointer",
              borderRadius: "8px",
            }}
          >
            <p className="mb-1 dropzone-text">
              <strong>Select a CSV file to upload</strong>
            </p>
            <p className="mb-3 text-muted small">or drag and drop it here</p>
            <button
              type="button"
              className="btn btn-danger px-md-5 fs-md-12 px-3"
              onClick={() => document.getElementById("file-upload").click()}
              disabled={!selectedCompany}
            >
              Upload CSV
            </button>
            <input
              id="file-upload"
              type="file"
              accept=".csv"
              onChange={handleChange}
              style={{ display: "none" }}
            />
          </div>

          {/* Upload Modal */}
          <UploadModel
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            uploadApi={uploadApi}
            setUploadApi={setUploadApi}
            handlebulkupload={() => handleEmployeebulkupload(selectedCompany)}
            selectedFileName={selectedFileName}
            loading={loading}
          />


        </div>
      </div>
    </>
  );
};

export default EmployeeBulkUpload;
